import { render } from "./ModalMatiere.vue?vue&type=template&id=0552a9d0"
import script from "./ModalMatiere.vue?vue&type=script&lang=js"
export * from "./ModalMatiere.vue?vue&type=script&lang=js"

import "./ModalMatiere.vue?vue&type=style&index=0&id=0552a9d0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__